.container {
  display: flex;
  flex-direction: row;
  height: 100%;

  @media screen and (max-width: $bp-medium) {
    display: flex;
  }
}

.left-container {
  display: flex;
  flex-direction: column;
  padding-top: 1.6rem;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  min-width: 0;
  width: 6.4rem;
  background-color: var(--color-surfaces-bg-recessed);
  & > svg {
    display: none;
    height: 2.4rem;
    fill: #ffffff;
  }

  &[data-icon='true'] {
    // This is the space selector
    & > div:not([data-radix-collection-item]) {
      & > div:last-child > svg {
        display: none;
      }

      & > div {
        padding: 0;
        flex-direction: column;
        gap: 0.4rem;

        & > p,
        & > div > span:last-child {
          display: none;
        }
      }
    }
  }
}
